import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-6">
        <p className="text-8xl font-bold text-[var(--color-primary)] mb-2">404</p>
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">Strona nie istnieje</h1>
        <p className="text-gray-500 mb-8">
          Podany adres URL nie odpowiada żadnej stronie w systemie ELGW5.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[var(--color-primary-hover)] text-white px-5 py-2.5 rounded-lg text-sm font-medium hover:bg-[var(--color-primary-hover)] transition-colors"
        >
          Wróć do pulpitu
        </Link>
      </div>
    </div>
  );
}
